import client from '../http_client';
import {
  CheckoutSessionRequest,
  CheckoutSessionResponse,
  CancelSessionRequest,
  ManageSessionRequest,
  PortalSessionResponse,
  SubscriptionStatusResponse,
} from './types';

export const root = '/v1/account';

export class AccountService {
  /**
   * Get current subscription status
   */
  public static async getCurrentSubscription(): Promise<SubscriptionStatusResponse> {
    const url = `${root}/subscription/current`;
    const response = await client.get<SubscriptionStatusResponse>(url);
    return response.data;
  }

  /**
   * Create a checkout session for upgrading/subscribing to a plan
   */
  public static async createCheckoutSession(
    request: CheckoutSessionRequest,
  ): Promise<CheckoutSessionResponse> {
    const url = `${root}/checkout/sessions`;
    const response = await client.post<CheckoutSessionResponse>(url, request);
    return response.data;
  }

  /**
   * Cancel subscription and get portal session URL
   */
  public static async cancelSubscription(
    request: CancelSessionRequest,
  ): Promise<PortalSessionResponse> {
    const url = `${root}/subscription/cancel`;
    const response = await client.post<PortalSessionResponse>(url, request);
    return response.data;
  }

  /**
   * Manage subscription and get portal session URL
   */
  public static async changePlan(request: ManageSessionRequest): Promise<PortalSessionResponse> {
    const url = `${root}/subscription/change-plan`;
    const response = await client.post<PortalSessionResponse>(url, request);
    return response.data;
  }

  /**
   * Reactivate subscription
   */
  public static async reactivateSubscription() {
    const url = `${root}/subscription/reactivate`;
    await client.post(url);
  }
}
